import React from 'react'
import { css } from '@emotion/react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { colors } from 'shared-ui'
import { ClassicEditor, Essentials, Paragraph, Bold, Italic } from 'ckeditor5'
import 'ckeditor5/ckeditor5.css'

export default function WysiwygEditor({
    value = '',
    onBlur = () => { },
    height = '280px',
    ...props
}) {
    return (
        <div css={css`

            * {
                line-height: 1.5;
            }
            h1, h2, h3 {
                font-weight: 600;
            }
            h1 { font-size: 2.25em; }
            h2 { font-size: 2em; }
            h3 { font-size: 1.75em; }

            .ck {
                --ck-color-base-background: #1f1f1f;
                --ck-color-base-foreground: #2a2a2a;
                --ck-color-base-border: #444;
                --ck-content-font-color: #fff;
                --ck-color-base-text: #fff;
            }

            .ck-content {
                height: ${height};
                color: white !important;
            }

            --ck-color-base-background: #1e1e1e;
            --ck-color-base-foreground: #2d2d2d;
            --ck-color-text: #ffffff;

            --ck-color-toolbar-background: ${colors.eventDark};

            --ck-color-button-default-hover-background: #3d3d3d;

            .ck-editor__editable {
                border-color: #444 !important;
            }

            .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
                border-color: #444 !important;
            }

            .ck.ck-editor__main > .ck-editor__editable.ck-focused {
                border-color: #666 !important;
            }

        `} {...props}>
            <CKEditor
                editor={ClassicEditor}
                config={{
                    licenseKey: 'GPL',  // use the open-source version
                    plugins: [Essentials, Paragraph, Bold, Italic],
                    toolbar: ['bold', 'italic'],
                }}
                data={value}
                onBlur={(e, ed) => {
                    onBlur(ed.data.get())
                }}
            />
        </div>
    )
}
